import { AxiosInstance } from 'axios';
import { SyncProductInput } from './inputs';
import { ProductRef } from './refs';

export default class Product {
    private basePath = '/rest/product';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Sync product data by its external ID
    synch = async (input: SyncProductInput): Promise<ProductRef> => {
        const { data } = await this.http.post(`${this.basePath}/sync`, input);

        return data;
    };
}
